/* Xinzuo · animaciones sutiles al bajar. Si el usuario pidió menos movimiento, no hace nada. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  document.documentElement.classList.add('xz-motion');
  var SEL = '.xz-head, .xz-card, .xz-step, .xz-story__media, .xz-story__body, .xz-trust > div, .xz-cta, .xz-faq, .xz-page-head, .xz-page-head__img, .xz-contact > div, .xz-banner__box, .xz-coll-head__box';
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
  function init() {
    document.querySelectorAll(SEL).forEach(function (el) {
      if (el.classList.contains('xz-reveal')) return;
      var i = Array.prototype.indexOf.call(el.parentElement.children, el);
      el.style.setProperty('--xz-d', Math.min(i, 5) * 80 + 'ms');
      el.classList.add('xz-reveal');
      io.observe(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // red de seguridad: nada queda oculto si algo falla
  setTimeout(function () { document.querySelectorAll('.xz-reveal:not(.is-in)').forEach(function (el) {
    if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in');
  }); }, 2500);
})();
